import { Map as iMap } from 'immutable';
import * as constants from './billing-constants';

const initialState = iMap({
  isInitial: true,
  errorMessage: '',
  invoices: [],
  hasMoreInvoices: false,
});

const defaultErrorMessage = 'An unknown error has happened. Please try again or contact support@tourconnect.com';

export function billing(state = initialState, action) {
  switch (action.type) {
    case constants.BILLING_ERROR: {
      return state.merge({ errorMessage: action.payload.message || defaultErrorMessage });
    }
    case constants.RESET_BILLING_ERROR: {
      return state.merge({ errorMessage: '' });
    }
    case constants.BILLING_LOADING: {
      return state.merge({ isLoading: action.loading });
    }
    case constants.CANCEL_SUBSCRIPTION: {
      return state.merge({ cancelAtPeriodEnd: true });
    }
    case constants.GET_COUPON: {
      return state.merge({ coupon: action.payload });
    }
    case '{billing} getInvoices_SUCCESS':
      return state.merge({
        invoices: action.payload.data,
        hasMoreInvoices: action.payload.has_more,
      });
    case 'SELECT_PLAN':
    case 'GET_BILLING':
    case 'ADD_CREDIT_CARD':
    case 'UPGRADE_PLAN':
      if (state === initialState) return iMap(action.payload);
      return state.merge(iMap(action.payload));
    case 'CLEAR_STORES':
    case 'LOG_OUT':
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/billing/billing-reducer.js